import React, { useEffect, useState } from "react";
import axios from "axios";
import { URL_START } from '../../data/config';

const AirportData = () => {
  const [airportData, setAirportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [icaoInput, setIcaoInput] = useState("");
  const [iataInput, setIataInput] = useState("");
  const [nameInput, setNameInput] = useState("");

  useEffect(() => {
    if (icaoInput || iataInput || nameInput) {
      fetchAirportData();
    } else {
      setAirportData([]); // Clear the data
    }
  }, [icaoInput, iataInput, nameInput]); // Trigger fetch when input changes

  // fetch airport data from the backend
  const fetchAirportData = async () => {
    setLoading(true);
    try {
      let response;
      if (icaoInput) {
        response = await axios.get(`${URL_START}/api/airports/search/icao?q=${icaoInput}`);
      } else if (iataInput) {
        response = await axios.get(`${URL_START}/api/airports/search/iata?q=${iataInput}`);
      } else if (nameInput) {
        response = await axios.get(`${URL_START}/api/airports/search/name?q=${nameInput}`);
      }
      setAirportData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setAirportData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleIcaoSubmit = (e) => {
    if (e.key === "Enter") {
      fetchAirportData();
    }
  };

  const handleIataSubmit = (e) => {
    if (e.key === "Enter") {
      fetchAirportData();
    }
  };

  const handleNameSubmit = (e) => {
    if (e.key === "Enter") {
      fetchAirportData();
    }
  };

  return (
    <div className="text-white">
      <div className="flex space-x-4 p-2 bg-gray-400">
        <input
          type="text"
          placeholder="ICAO"
          value={icaoInput}
          onChange={(e) => setIcaoInput(e.target.value.toUpperCase())}
          onKeyDown={handleIcaoSubmit}
          maxLength={4}
          className="text-sm pl-2 monospace-font bg-gray-200 text-black border border-gray-600 w-1/4 p-1"
        />
        <input
          type="text"
          placeholder="IATA"
          value={iataInput}
          onChange={(e) => setIataInput(e.target.value.toUpperCase())}
          onKeyDown={handleIataSubmit}
          maxLength={3}
          className="text-sm pl-2 monospace-font bg-gray-200 text-black border border-gray-600 w-1/4 p-1"
        />
        <input
          type="text"
          placeholder="Name"
          value={nameInput}
          onChange={(e) => setNameInput(e.target.value)}
          onKeyDown={handleNameSubmit}
          className="text-sm pl-2 monospace-font bg-gray-200 text-black border border-gray-600 w-1/2 p-1"
        />
      </div>
      {/* Show loading message while fetching */}
      {loading ? (
        <p className="text-center text-white">Loading...</p>
      ) : (
        airportData.length > 0 && (
        <div className="table-container text-sm overflow-x-auto">
        <table className="min-w-full table-auto border-collapse w-full">
            <thead>
            <tr className="bg-gray-400">
                <th className="p-2 text-left">Name</th>
                <th className="p-2 text-left">ICAO</th>
                <th className="p-2 text-left">IATA</th>
                <th className="p-2 text-left">Municipality</th>
                <th className="p-2 text-left">Region</th>
                <th className="p-2 text-left">Country</th>
                <th className="p-2 text-left">Altitude</th>
                <th className="p-2 text-left">Status</th>
            </tr>
            </thead>
              <tbody className="text-black">
                {airportData.map((airport, index) => (
                  <tr
                    key={airport.id}
                    className={`table-line ${index % 2 === 0 ? "bg-gray-600" : "bg-gray-700"}`}
                  >
                    <td className="p-2 border text-left">{airport.name}</td>
                    <td className="p-2 border text-left">{airport.icao}</td>
                    <td className="p-2 border text-left">{airport.iata || "N/A"}</td>
                    <td className="p-2 border text-left">{airport.municipality}</td>
                    <td className="p-2 border text-left">{airport.region}</td>
                    <td className="p-2 border text-left">{airport.country}</td>
                    <td className="p-2 border text-left">{airport.altitude} ft</td>
                    <td className="p-2 border text-left">{airport.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
};

export default AirportData;
